<template>
    <div class="device-type-manange relative">
        <div class="buttons" :style="{position: button_position}">
            <el-button :id="'doctorAdd'" @click="addUser" v-if="role_id != 2 && role_id != 24">注册账号</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">&ensp;&ensp;&ensp;&ensp;姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">用户类型：</span>
                <el-select class="status"
                           clearable
                           v-model="type" placeholder="请选择用户类型" style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allType"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">手机号码：</span>
                <el-input v-model="mobile" placeholder="模糊搜索手机号码"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">审核状态：</span>
                <el-select class="status"
                           clearable
                           v-model="status" placeholder="请选择状态" @change="search()" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <!-- 表单结束 -->

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
<!--            <el-table-column prop="id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="50" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="95" prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="110" prop="mobile" label="手机号码" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="165" prop="id_card" label="身份证号码" align="center" label-class-name="label"></el-table-column>
<!--            <el-table-column width="165" prop="address" label="身份证住址" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="110" prop="type_text" label="用户类型" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="50" prop="sex_text" label="性别" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="50" prop="age" label="年龄" align="center" label-class-name="label" v-slot="scope">
                <div v-if="scope.row.age > 0">{{scope.row.age}}</div>
            </el-table-column>
            <el-table-column prop="bloc_name" label="单位" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="140" prop="position" label="职务" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="user_title" label="职称" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="80" prop="remark" label="身份证银行卡照片" align="center" label-class-name="label" v-slot="scope">
                <div style="display: inline;margin-right: 2px" v-for="(img, index) in scope.row.images"
                     @click="previewImage(scope.row.images, index)">
                    <i class="el-icon-picture-outline"></i>
                </div>
            </el-table-column>
            <el-table-column width="165" label="其他" align="center" label-class-name="label" v-slot="scope">
                <div v-if="scope.row.type == 1" style="text-align: left;">
                    <span v-for="user in scope.row.other" v-if="user.user_name && user.mobile">
                        <span>联系人：</span><br />
                        <span>{{ user.user_name }}：{{ user.mobile }}</span>
                    </span>
                </div>
            </el-table-column>
            <el-table-column width="160" prop="create_date" label="申请时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="80" prop="status" label="状态" align="center" label-class-name="label"  v-slot="scope">
                <span style="color: #ff3333;" v-if="scope.row.status_number == 1">{{ scope.row.status }}</span>
                <span v-else>{{ scope.row.status }}</span>
            </el-table-column>
            <el-table-column width="100" label="操作" align="center" label-class-name="label" v-slot="scope">
                <el-button v-if="scope.row.status_number != 2 && scope.row.status_number != 4" @click="edit(scope.row)"
                           type="text" size="mini">编辑
                </el-button>
                <el-button v-if="scope.row.status_number == 1 && userCheck(scope.row) && scope.row.bloc_name" @click="goEdit(scope.row, 2)"
                           type="text" size="mini">通过
                </el-button>
                <el-button v-if="scope.row.status_number == 1" @click="goEdit(scope.row, 3)"
                           type="text" size="mini">拒绝
                </el-button>
                <el-button v-if="(scope.row.status_number != 2 && scope.row.status_number != 4) || (scope.row.user_role_status == 3)" @click="delApply(scope.row, 3)"
                           type="text" size="mini">注销
                </el-button>
                <el-button v-if="(scope.row.type == 1 && scope.row.status_number == 2 && scope.row.user_role_status == 3 && scope.row.esign_contract_status == 1 && role_id != 24)" @click="esignPayDialog(scope.row)"
                           type="text" size="mini">线下付款
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>

        <el-dialog title="证件预览" :visible.sync="dialogImgFormVisible">
            <el-carousel ref="image_box" id="image_detail" indicator-position="outside" height="500px" :autoplay="false" :initial-index="0" :loop="false">
                <el-carousel-item v-for="(url, n) in imageUrl" :key="n">
                    <div class="image_box">
                        <el-image :src="url"></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
        <el-dialog custom-class="ad_dialog_box" title="资料审核不通过" :visible.sync="dialogAdFormVisible">
            <span class="fs-14 pd-r-10">修改意见：</span>
            <el-select v-model="message_content" style="width: 80%;" multiple placeholder="请选择修改意见">
                <el-option
                    v-for="item in checkMessageDoctor"
                    :key="item.message"
                    :label="item.message"
                    :value="item.message"
                    v-if="dialog_box_user_role == '2'"
                >
                </el-option>
                <el-option
                    v-for="item in checkMessageUser"
                    :key="item.message"
                    :label="item.message"
                    :value="item.message"
                    v-if="dialog_box_user_role == '1'"
                >
                </el-option>
            </el-select>
            <div class="el-form-item" style="margin-top: 40px;margin-bottom: 10px;">
                <el-button type="info"  @click="cancleHandle">取消</el-button>
                <el-button type="primary" style="margin-left: 40px;" @click="applyHandle(3)">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="payDialogTitle"
            :visible.sync="payDialogVisible"
            width="30%"
            center>
            <el-form label-position="right" :model="payForm" :rules="payRules" ref="payForm"
                     label-width="80px"
                     class="form" style="width: 90%;margin: 20px auto 0 auto;" autocomplete="off">
                <el-form-item label="付款方式" prop="pay_type" style="margin-bottom: 0;">
                    <el-select v-model="payForm.pay_type" placeholder="请选择付款方式"
                               style="width: 100%;">
                        <el-option
                            v-for="item in payType"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="电子协议">
                    <a @click="previewPdf" style="margin-left: 5px;color: #315efb;cursor: pointer;text-decoration: underline;">协议详情</a>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="payDialogVisible = false">取 消</el-button>
                <el-button type="success" @click="doEsignPay('payForm')">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog title="协议预览" class="contract_view" :visible.sync="dialogContractFormVisible">
            <el-carousel ref="image_box" indicator-position="outside" height="700px" :autoplay="false" :initial-index="0" :loop="false">
                <el-carousel-item v-for="url in pdfUrl" >
                    <div class="image_box" style="height: 100%;">
                        <pdf
                            v-for="i in url.pages"
                            :key="i"
                            :page="i"
                            :src="url.src" ></pdf>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {authUrlCheck, fileType, isMobile} from "@/api/order";
    import {getUserInfos} from "@/utils/userInfos";
    import pdf from "vue-pdf";

    export default {
        components: {
            pdf
        },
        inject: ['user_apply_count_params','user_apply_detail_params'],
        data() {
            return {
                imgUrl: env.IMG_COMMON_URL_PREFIX,
                role_id: 0,
                dialogAdFormVisible: false,
                message_content:[],
                check_id:'',
                dialogImgFormVisible: false,
                imgPREFIX: env.IMG_COMMON_URL_PREFIX,
                imageUrl: [],
                dialog_box_user_role: '0',
                checkMessageUser:[
                    {message:'您的身份证信息有误，请重新填写！'},
                    {message:'您的单位名称不符合要求！'},
                    {message:'您的职务名称不符合要求！'},
                ],
                checkMessageDoctor:[
                    {message:'您的身份证信息有误，请重新填写！'},
                    {message:'您的银行卡信息有误，请重新填写！'},
                    {message:'您的单位名称不符合要求！'},
                    {message:'您的职务名称不符合要求！'},
                ],
                allStatus: [
                    {
                        id: 1,
                        name: '待审核',
                    },
                    {
                        id: 2,
                        name: '通过',
                    },
                    {
                        id: 3,
                        name: '被拒',
                    },
                    {
                        id: 4,
                        name: '注销',
                    },
                ],
                allType: [
                    {
                        id: 1,
                        name: '特属服务对象',
                    },
                    {
                        id: 2,
                        name: '特属专家',
                    },
                ],
                payType: [
                    {
                        id: 1,
                        name: '1年1付',
                    },
                    {
                        id: 2,
                        name: '全款',
                    },
                ],
                payForm: {
                    id: '',
                    pay_type: '1',
                    file_url: '',
                    type: '',
                    user_name: '',
                },
                payRules: {
                    pay_type: [
                        {required: true, message: "请选择付款方式", trigger: "blur"},
                    ],
                },
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                user_name: '',
                mobile: '',
                status: '',
                type: '',
                is_pagination_show: true,
                user_id: 0,
                button_position: 'absolute',
                payDialogVisible: false,
                payDialogTitle: '',
                dialogContractFormVisible: false,
                pdfUrl: []
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
                this.is_mobile = true
            }
        },
        mounted() {
            let userInfo = getUserInfos()
            if (userInfo) {
                this.user_id = parseInt(userInfo.id)
                this.role_id = parseInt(userInfo.role_id)
            }
            let prev_page = localStorage.getItem('prev_page');
            if (prev_page == 'apply_edit') {
                let page = 0;
                this.user_name = localStorage.getItem('apply_list_user_name')
                this.mobile = localStorage.getItem('apply_list_mobile')
                this.status = parseInt(localStorage.getItem('apply_list_status'))||''
                this.type = parseInt(localStorage.getItem('apply_list_type'))||''

                if (this.user_name == 'undefined' || this.user_name == 'null') {
                    this.user_name = ''
                }
                if (this.mobile == 'undefined' || this.mobile == 'null') {
                    this.mobile = ''
                }
                if (this.type == 'undefined' || this.type == 'null') {
                    this.type = ''
                }
                if (this.status == 'undefined' || this.status == 'null') {
                    this.status = ''
                }
                this.page = parseInt(localStorage.getItem('page'))
                this.perpage = parseInt(localStorage.getItem('perpage'))
                this.is_pagination_show = false
            } else {
                this.mobile = this.$route.params.mobile || ''
                this.user_name = this.$route.params.user_name || ''
                this.status = this.$route.params.status || ''
            }
            this.getList();
        },
        methods: {
            // 图片预览
            async previewPdf(){
                let url = '';
                let local_url = '';
                local_url = url = this.payForm.file_url;
                let num_pages = 0;
                url = pdf.createLoadingTask(url)
                await url.promise.then(pdf => {
                    num_pages = pdf.numPages
                    this.pdfUrl.push({
                        src: local_url,
                        pages: num_pages
                    });
                }).catch((e)=>{});

                this.dialogContractFormVisible = true;

            },
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'applyListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_name: this.user_name,
                        mobile: this.mobile,
                        status: this.status,
                        type: this.type,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        // 以序号代替ID
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '待审核';
                                res.data.data.list[i].status_number = '1';
                                break;
                            case '2':
                                res.data.data.list[i].status = '通过';
                                res.data.data.list[i].status_number = '2';
                                break;
                            case '3':
                                res.data.data.list[i].status = '被拒';
                                res.data.data.list[i].status_number = '3';
                                break;
                            case '4':
                                res.data.data.list[i].status = '已注销';
                                res.data.data.list[i].status_number = '4';
                                break;
                        }
                        if (res.data.data.list[i].delete_date) {
                            res.data.data.list[i].status = '已注销';
                        }
                        switch (res.data.data.list[i].sex) {
                            case '1':
                                res.data.data.list[i].sex_text = '男';
                                break;
                            case '2':
                                res.data.data.list[i].sex_text = '女';
                                break;

                        }
                        switch (res.data.data.list[i].type) {
                            case '1':
                                res.data.data.list[i].type_text = '特属服务对象';
                                break;
                            case '2':
                                res.data.data.list[i].type_text = '特属专家';
                                if (res.data.data.list[i].department_name) {
                                    res.data.data.list[i].position = `${res.data.data.list[i].position}(${res.data.data.list[i].department_name})`
                                }
                                break;
                        }
                        if (res.data.data.list[i].other) {
                            res.data.data.list[i].other = JSON.parse(res.data.data.list[i].other)
                        }
                        if (res.data.data.list[i].photos) {
                            res.data.data.list[i].images = JSON.parse(res.data.data.list[i].photos)
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;

                    localStorage.setItem('apply_list_user_name', this.user_name)
                    localStorage.setItem('apply_list_mobile', this.mobile)
                    localStorage.setItem('apply_list_type', this.bloc_id)
                    localStorage.setItem('apply_list_status', this.status)
                    localStorage.setItem('prev_page', 'apply_list')
                    localStorage.setItem('page', this.page)
                    localStorage.setItem('perpage', this.perpage)
                    this.is_pagination_show = true;
                });
            },
            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.user_name = "";
                this.mobile = "";
                this.status = "";
                this.type = "";
                this.page = 1;
                this.perpage = 10;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },
            // 预览
            async previewImage(data, index){
                if (this.$refs.image_box) {
                    this.$refs.image_box.setActiveItem(index)
                }
                this.imageUrl = [];

                if (data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        this.imageUrl.push(this.imgPREFIX + data[i].url);
                    }
                }

                this.active_index = index
                this.dialogImgFormVisible = true;

            },
            // 如果没有身份证号、银行卡号则不显示通过按钮
            userCheck(data) {
                let photos = null;
                if (data.photos) {
                    photos = JSON.parse(data.photos)
                }
                let res = true;
                if (data.type == 1 && !data.id_card) {
                    // 对象没有身份证号
                    res = false;
                }
                if (data.type == 2 && (!data.bank_card || !data.id_card)) {
                    // 专家没有身份证号、没有银行卡号
                    res = false;
                }
                return res;
            },
            goEdit(data, status = 2) {
                let msg = null;
                let status_text = null;
                if (status == 2) {
                    status_text = '同意';
                } else {
                    status_text = '拒绝';
                }
                msg = `是否${status_text}${data.type_text}${data.user_name}申请加入儒悘网平台？`
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.check_id = data.id
                    if (status != 2) {
                        this.dialogAdFormVisible = true;
                        this.dialog_box_user_role= data.type.toString()
                    } else {
                        this.applyHandle(2)
                    }

                }).catch(() => {
                });
            },
            edit(data) {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/apply/ApplyEdit', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({
                    name: "applyEdit", params: {
                        id: data.id,
                    }
                });
                return;
            },
            // 跳转添加页
            addUser() {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/apply/ApplyEdit', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({name: "applyEdit", params: {}});
                return;
            },
            cancleHandle() {
                this.check_id = '';
                this.dialogAdFormVisible = false;
                this.message_content = [];
            },
            applyHandle(status) {
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'handleUserApply',
                    params: {
                        id: this.check_id,
                        status: status,
                        remark: this.message_content,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '审核处理成功！',
                        duration: 1500,
                    });
                    this.dialogAdFormVisible = false;
                    this.page = 1;
                    this.getList();
                });
            },
            delApply(data) {
                let user_type = null;
                if (parseInt(data.type) === 1) {
                    user_type = `特属服务对象`
                } else {
                    user_type = `特属专家`
                }
                this.$confirm(`确定要注销${user_type}：${data.user_name}(${data.mobile})的加入申请吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminCustomerServices',
                        method: 'userLogout',
                        params: {
                            id: data.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '注销成功！',
                            duration: 1500,
                        });
                        this.getList();
                    });

                }).catch(() => {
                });
            },
            esignPayDialog(data){
                this.payForm.id = data.id
                this.payForm.type = data.type
                this.payForm.file_url = this.imgUrl + data.file_url
                this.payForm.user_name = data.user_name
                this.payForm.pay_type = parseInt(data.esign_pay_type) || 1
                this.payDialogTitle = `线下付款处理：${data.user_name}`
                this.payDialogVisible = true
            },
            doEsignPay(formName) {
                if (this.payForm.type != 1) {
                    this.$message({
                        type: "error",
                        message: '非特属服务对象不能处理线下付款！',
                        duration: 1500,
                    });
                    return;
                }

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$confirm(`特属服务对象 ${this.payForm.user_name } 是否已在线下完成付款？`, '提示', {
                            confirmButtonText: '已付款',
                            cancelButtonText: '未付款',
                            type: 'warning'
                        }).then(() => {
                            let params = {
                                servername: 'Ruyi_AdminCustomerServices',
                                method: 'doEsignPay',
                                params: {
                                    id: this.payForm.id,
                                    pay_type: this.payForm.pay_type,
                                }
                            };
                            this.$api.service(params).then(res => {
                                if (!check(res)) {
                                    return;
                                }
                                this.$message({
                                    type: "success",
                                    message: '线下付款操作处理成功！',
                                    duration: 1500,
                                });
                                this.payDialogVisible = false
                                this.getList();
                            });

                        }).catch(() => {
                        }).finally(()=>{

                        });
                    }
                })
            }

        },
        watch: {
            user_apply_count_params: {
                immediate: true,
                deep: true,
                handler(nVal, oVal) {
                    if (nVal && localStorage.getItem('prev_page')==='notice_sidebar') {
                        this.user_name = "";
                        this.mobile = "";
                        this.type = "";
                        this.status = 1;
                        this.page = 1;
                        this.perpage = 10;
                        this.getList();
                    }
                },
            },
            user_apply_detail_params: {
                immediate: true,
                deep: true,
                handler(nVal, oVal) {
                    if (nVal && nVal.user_name && nVal.user_name != this.user_name) {
                        this.status = "";
                        this.user_name = nVal.user_name
                        this.mobile = nVal.mobile
                        this.getList();
                    }

                },
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .image_box {
        height: 500px;
        overflow: hidden;
        overflow-y: auto;

        image {
            width: 100%;
        }
    }
    .el-icon-picture-outline,.ad-coentent{color: #6B99F0;cursor: pointer;}
    .ad_dialog_box{
        margin-top: 30vh !important;
        min-width: auto !important;
        width: 540px; height: auto;
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-input {width: 100% !important;}
    .contract_view{
        .el-dialog{
            margin-top: 5vh !important;
        }
    }
</style>
